var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "ukDisclaimerModal", "data-backdrop": "static" },
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("img", {
                staticClass: "close-icon",
                attrs: {
                  "data-dismiss": "modal",
                  src: "/static/images/icons/close_icon.svg",
                  alt: "close-icon",
                },
              }),
              _c("div", { staticClass: "card text-center" }, [
                _c("img", {
                  staticClass: "info-logo",
                  attrs: {
                    src: require("../../../public/static/images/icons/info_icon_active.svg"),
                    alt: "checkbox-icon",
                  },
                }),
                _c("div", { staticClass: "card-title" }, [
                  _c("p", { staticClass: "verification-text" }, [
                    _vm._v(
                      "Classification Rules and Information for United Kingdom"
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-12 card-text" }, [
                    _c("p", { staticClass: "success-message" }, [
                      _vm._v(
                        "Classification in the United Kingdom is currently in accordance with the classification rules defined in Annex IX of the EU MDD 93/42/EEC. However, there has been discussion regarding possible future changes to the regulatory framework, including the classification rules. Therefore, classification may change in the future. Additionally, this classification is applicable for devices placed on the market in Great Britain (England, Scotland, and Wales), but devices placed on the market in Northern Ireland fall under the regulatory framework of the EU."
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-12 ok-btn" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-green-button",
                      attrs: { "data-dismiss": "modal" },
                    },
                    [_vm._v("OK")]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }